import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAIPkS9eaJpOL7tbrXffYZwqAGtzM41niY",
    authDomain: "smart-repair-center.firebaseapp.com",
    projectId: "smart-repair-center",
    storageBucket: "smart-repair-center.firebasestorage.app",
    messagingSenderId: "743760522816",
    appId: "1:743760522816:web:f4c4bb4ef962cc6a4439a5",
    measurementId: "G-9L5VCWX711"
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);